/**
 * The red line under an invite form, shared by the Account page form
 * (TeamMembersSection, source 'settings') and the project page's
 * InviteTeamModal (source 'project_header') so the two cannot drift.
 *
 * When the refusal is one a plan upgrade fixes (seat cap, lapsed trial), the
 * server's own sentence already says "Upgrade your plan..." (routes/teams.ts);
 * this adds the way there: "Upgrade plan" to /billing. Every other refusal
 * renders exactly as before. Invite at peak, 2026-09-30.
 *
 * Analytics: `invite_upgrade_clicked { source, code }`, once per click.
 */
import { Link } from 'react-router-dom';
import { capture } from '@/lib/analytics';
import { INVITE_FORM_COPY, isUpgradeableInviteRefusal } from '@/lib/inviteEmail';

interface InviteRefusalMessageProps {
  message: string;
  code: string | null;
  source: 'settings' | 'project_header';
}

export function InviteRefusalMessage({ message, code, source }: InviteRefusalMessageProps) {
  return (
    <p className="mt-2 text-xs text-red-600" role="alert">
      {message}
      {isUpgradeableInviteRefusal(code) && (
        <>
          {' '}
          <Link
            to="/billing"
            className="text-primary-600 font-medium hover:underline"
            onClick={() => capture('invite_upgrade_clicked', { source, code })}
          >
            {INVITE_FORM_COPY.upgrade}
          </Link>
        </>
      )}
    </p>
  );
}
